import { create } from 'zustand';
import type { PanelAdminView } from '@livepuls/types';
import { api } from '../lib/api.js';

export interface PairingInfo {
  pairingCode: string;
  paired: boolean;
  pairedAt: string | null;
}

interface PairingState {
  byPanelId: Record<string, PairingInfo>;
  fetchAll: () => Promise<void>;
  regenerate: (panelId: string) => Promise<void>;
}

/**
 * Pairing-Metadaten (Code / gepaart / gepaart-seit) leben NICHT im
 * Draft/Live-Config-Snapshot (useConfigStore) — der ist öffentlich lesbar
 * und darf keine Pairing-Codes enthalten. Stattdessen ein eigener Store,
 * gespeist aus der admin-only `GET /api/v1/panels`-Antwort (PanelAdminView).
 */
export const usePairingStore = create<PairingState>((set, get) => ({
  byPanelId: {},

  async fetchAll() {
    const panels = await api.get<PanelAdminView[]>('/api/v1/panels');
    const byPanelId: Record<string, PairingInfo> = {};
    for (const p of panels) {
      byPanelId[p.id] = { pairingCode: p.pairingCode, paired: p.paired, pairedAt: p.pairedAt };
    }
    set({ byPanelId });
  },

  async regenerate(panelId) {
    const res = await api.post<{ pairingCode: string }>(
      `/api/v1/panels/${panelId}/pairing/regenerate`,
    );
    set({
      byPanelId: {
        ...get().byPanelId,
        [panelId]: { pairingCode: res.pairingCode, paired: false, pairedAt: null },
      },
    });
  },
}));
